import sampleService from '@/api/sample'
import { isWsSampleOrigin } from './batchSource'

const toIdentifier = value =>
  typeof value === 'string' || typeof value === 'number' ? String(value).trim() : ''

const toNumericId = value => {
  if (typeof value === 'number' && (!Number.isSafeInteger(value) || value <= 0)) {
    return null
  }

  const id = toIdentifier(value)
  return /^\d+$/.test(id) && /[1-9]/.test(id) ? id : null
}

const getSampleBarcode = sample =>
  toIdentifier(typeof sample === 'object' && sample !== null
    ? sample.barcode || sample.bar_code
    : sample)

export async function resolveBatchRouteId({
  batchIdentifier,
  batchId,
  source,
  samples = [],
  results = [],
} = {}) {
  const identifier = toIdentifier(batchIdentifier)

  if (isWsSampleOrigin(source)) {
    return identifier || null
  }

  const numericId = toNumericId(batchId) || toNumericId(batchIdentifier)
  if (numericId) return numericId
  if (!identifier) return null

  // A move returns the external LT code for AOL as well as LIS. Resolve AOL
  // through a moved sample before opening a route that expects its internal ID.
  const moveResults = Array.isArray(results) ? results : []
  const candidates = moveResults.length
    ? moveResults.filter(result => result?.status === 'OK')
    : Array.isArray(samples) ? samples : []
  const barcodes = [...new Set(candidates.map(getSampleBarcode).filter(Boolean))]

  for (const barcode of barcodes) {
    const response = await sampleService.getSampleByBarcode(barcode)
    const sample = response?.data
    const sampleBatchId = toNumericId(sample?.batch_id)

    if (
      toIdentifier(sample?.batch_identifier) === identifier &&
      sampleBatchId &&
      !isWsSampleOrigin(sample?.origem)
    ) {
      return sampleBatchId
    }
  }

  throw new Error('Não foi possível identificar o lote AOL criado.')
}
